import {ResourceParams, resources} from "../../../../models/resource/resources";
import {BloggerGroupModalConfig} from "../types/blogger-groups.types";
import {NewBloggerGroupsModalComponent} from "../new-blogger-groups-modal/new-blogger-groups-modal.component";
import {DetachBloggerGroupsModalComponent} from "../detach-blogger-groups-modal/detach-blogger-groups-modal.component";
import {
  CurrentBloggerGroupsModalComponent
} from "../current-blogger-groups-modal/current-blogger-groups-modal.component";

export const bloggerGroupsResourceType: ResourceParams = resources['blogger-groups'];

export const bloggerGroupModalConfig: Record<string, BloggerGroupModalConfig> = {
  newBloggerGroups: {
    component: NewBloggerGroupsModalComponent,
    fieldName: 'newBloggerGroups',
    width: '500px'
  },
  currentBloggerGroups: {
    component: CurrentBloggerGroupsModalComponent,
    fieldName: 'currentBloggerGroups',
    width: '500px'
  },
  detachBloggerGroups: {
    component: DetachBloggerGroupsModalComponent,
    fieldName: 'detachBloggerGroups',
    width: '500px'
  }
}
